export default "__VITE_ASSET__88de8e6b__"